var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcLiquidity(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_liquidity",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: 40,
    height: 40,
    rx: 4,
    transform: "translate(0)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_86",
    "data-name": "Group 86",
    transform: "translate(-7.307 -4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_172",
    "data-name": "Path 172",
    d: "M27.854-24.323a1.617,1.617,0,0,0-2.631,0C22.2-19.945,15-9.03,15-4.243,15,1.817,20.166,6.731,26.538,6.731S38.077,1.817,38.077-4.243C38.077-9.03,30.88-19.945,27.854-24.323Z",
    transform: "translate(-5 30)",
    fill: "rgba(3,209,207,0.99)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_173",
    "data-name": "Path 173",
    d: "M27.854-24.323a1.617,1.617,0,0,0-2.631,0C22.2-19.945,15-9.03,15-4.243,15,1.817,20.166,6.731,26.538,6.731S38.077,1.817,38.077-4.243C38.077-9.03,30.88-19.945,27.854-24.323Z",
    transform: "translate(6.539 35.769)",
    fill: "#303fd0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Intersection_1",
    "data-name": "Intersection 1",
    d: "M0,16.035C0,12.383,4.19,5.162,7.521,0c2.2,3.9,4.017,7.858,4.017,10.266a11.188,11.188,0,0,1-10.2,10.9A10.505,10.505,0,0,1,0,16.035Z",
    transform: "translate(21.538 15.491)",
    fill: "#50d0fe",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLiquidity);
export default __webpack_public_path__ + "static/media/ic_liquidity.505b3f3092989052e6f990d498df3dd0.svg";
export { ForwardRef as ReactComponent };